(function () {
    'use strict';

    CompanyCustomerV2ComponentController.$inject = [
        '$scope',
        '$state',
        'PersonInfoSearch',
        'ParseLinks',
        'AlertService',
        'paginationConstants',
        '$translate',
        '$translatePartialLoader',
        'CompanyCustomerCustom',
        '$mdDialog',
        'DialogService',
        'CustomerGroupCustom',
        'UserCustom',
        'CustomerCustom',
        'InvoiceInfoCustom',
        'WalletService',
        'AlertToastService',
        '$mdToast',
        '$mdMedia'
    ];

    function CompanyCustomerV2ComponentController(
        $scope,
        $state,
        PersonInfoSearch,
        ParseLinks,
        AlertService,
        paginationConstants,
        $translate,
        $translatePartialLoader,
        CompanyCustomerCustom,
        $mdDialog,
        DialogService,
        CustomerGroupCustom,
        UserCustom,
        CustomerCustom,
        InvoiceInfoCustom,
        WalletService,
        AlertToastService,
        $mdToast,
        $mdMedia
    ) {

        var $ctrl = this;

        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;

        $ctrl.selectedId = '';

        $ctrl.getCompanyCustomerFormDataFunc = getCompanyCustomerFormDataFunc;
        $ctrl.editCompanyCustomerFormDataFunc = editCompanyCustomerFormDataFunc;
        $ctrl.deleteCustomerFormData = deleteCustomerFormData;
        $ctrl.customerGroupChanged = customerGroupChanged;

        $ctrl.createUser = createUser;
        $ctrl.onInvoiceHistoryTabClick = onInvoiceHistoryTabClick;
        $ctrl.sendWelcomeMessage = sendWelcomeMessage;
        $ctrl.openAddBalanceDialog = openAddBalanceDialog;

        $ctrl.customerFormData = null;
        $ctrl.columnCount = null;
        $ctrl.reserveHistorySearchQuery = null;
        $ctrl.customerStatuses = [
            'NEW_CUSTOMER',
            'VALID_CUSTOMER',
            'BLOCKED_CUSTOMER'
        ];

        $ctrl.user = {};
        $ctrl.hasUser = false;
        $ctrl.existUser = {};
        $ctrl.customerId = null;

        $ctrl.invoiceInfoList = null;
        $ctrl.invoiceHistoryLoaded = false;

        $ctrl.sendWelcomeMessageLoading = false;
        $ctrl.removeCreditLoading = false;

        $ctrl.totalBalance = 0;
        $ctrl.walletTransactions = [];

        if (!$ctrl.companyCustomer) {
            $ctrl.companyCustomer = {};
        }

        initializeFormCollections();

        loadAll();
        loadPage();

        function initializeFormCollections() {
            $ctrl.companyCustomer.singleRecordForms = [];
            $ctrl.companyCustomer.multiRecordForms = [];
            $ctrl.companyCustomer.singleRecordFormDatas = [];
            $ctrl.companyCustomer.multiRecordFormDatas = [];
        }

        function loadAll() {
            initializeFormCollections();

            if ($ctrl.companyCustomer.id) {
                loadCompanyCustomForms();
                loadCompanyCustomFormData();
                loadCustomerUserInfo();
            } else {
                initNewCustomerIntakeData();
            }

            loadAllCustomerGroups();
            loadCustomerWalletData();
        }

        function loadCompanyCustomForms() {
            var companyId = $ctrl.companyCustomer.companyId;

            if (!companyId) {
                return;
            }

            $ctrl.companyCustomer.forms =
                CompanyCustomerCustom
                    .getCompanyCustomForm(companyId)
                    .query(
                        function (forms) {
                            angular.forEach(forms, function (item) {
                                if (item.recordType === 'SINGLE_RECORD') {
                                    $ctrl.companyCustomer.singleRecordForms.push(item);
                                } else {
                                    $ctrl.companyCustomer.multiRecordForms.push(item);
                                }
                            });
                        },
                        handleRequestError
                    );
        }

        function loadCompanyCustomFormData() {
            CompanyCustomerCustom
                .getCompanyCustomFormDataByCompanyCustomerId(
                    $ctrl.companyCustomer.id
                )
                .query()
                .$promise
                .then(function (res) {
                    $ctrl.companyCustomer.singleRecordFormDatas = [];
                    $ctrl.companyCustomer.multiRecordFormDatas = [];
                    $ctrl.companyCustomer.formsData = res || [];

                    $ctrl.companyCustomer.formsData.sort(function (a, b) {
                        return b.id - a.id;
                    });

                    angular.forEach(
                        $ctrl.companyCustomer.formsData,
                        function (item) {
                            if (
                                !item.companyCustomForm ||
                                !item.companyCustomForm.recordType
                            ) {
                                return;
                            }

                            if (
                                item.companyCustomForm.recordType ===
                                'SINGLE_RECORD'
                            ) {
                                $ctrl.companyCustomer.singleRecordFormDatas.push(
                                    item
                                );

                                removeSingleRecordButton(
                                    item.companyCustomForm
                                );
                            } else {
                                $ctrl.companyCustomer.multiRecordFormDatas.push(
                                    item
                                );
                            }
                        }
                    );
                })
                .catch(handleRequestError);
        }

        function removeSingleRecordButton(companyCustomForm) {
            if (!companyCustomForm || !companyCustomForm.id) {
                return;
            }

            $ctrl.companyCustomer.singleRecordForms =
                $ctrl.companyCustomer.singleRecordForms.filter(
                    function (item) {
                        return item.id !== companyCustomForm.id;
                    }
                );
        }

        function loadPage() {
            $translatePartialLoader.addPart('personInfo');
            $translatePartialLoader.addPart('locationInfo');
            $translatePartialLoader.addPart('global');
            $translatePartialLoader.addPart('servant');
            $translatePartialLoader.addPart('customerStatus');

            $translate.refresh();
        }

        function getCompanyCustomerFormDataFunc(
            companyCustomFormId,
            companyCustomFormTitle
        ) {
            if (!companyCustomFormId) {
                return;
            }

            CompanyCustomerCustom
                .getNewCompanyCustomerFormData(companyCustomFormId)
                .query(
                    function (res) {
                        $ctrl.customerFormData = res;
                        $ctrl.customerFormData.companyCustomFormTitle =
                            companyCustomFormTitle;
                        $ctrl.customerFormData.companyCustomer =
                            $ctrl.companyCustomer;

                        openEditDataDialog($ctrl.customerFormData);
                    },
                    handleRequestError
                );
        }

        function editCompanyCustomerFormDataFunc(
            companyCustomFormId,
            companyCustomFormTitle,
            data
        ) {
            if (!data) {
                return;
            }

            $ctrl.customerFormData = angular.copy(data);
            $ctrl.customerFormData.companyCustomFormTitle =
                companyCustomFormTitle;
            $ctrl.customerFormData.companyCustomerId =
                $ctrl.companyCustomer.id;

            if (!$ctrl.customerFormData.companyCustomer) {
                $ctrl.customerFormData.companyCustomer =
                    $ctrl.companyCustomer;
            }

            openEditDataDialog($ctrl.customerFormData);
        }

        function openEditDataDialog(customerFormData) {
            if (!customerFormData) {
                return;
            }

            $ctrl.columnCount = 4;

            $mdDialog.show({
                locals: {
                    dialogData: customerFormData,
                    columnCount: $ctrl.columnCount
                },
                controller: ComponentIntakeDataDialogController,
                templateUrl:
                    'app/components/eyeson/intake-data-component/component-intake-data-dialog.html',
                controllerAs: '$ctrl',
                targetEvent: null,
                clickOutsideToClose: true
            });
        }

        function deleteCustomerFormData(formData) {
            if (!formData || !formData.id) {
                return;
            }

            DialogService
                .showConfirm(
                    'آیا از حذف اطلاعات مورد نظر اطمینان دارید؟'
                )
                .then(function () {
                    CompanyCustomerCustom
                        .companyCustomerFormData()
                        .delete(
                            {
                                id: formData.id
                            },
                            function () {
                                loadAll();
                            },
                            handleRequestError
                        );
                });
        }

        function loadAllCustomerGroups() {
            CustomerGroupCustom
                .getCustomerGroupsByCurrentCompany()
                .query()
                .$promise
                .then(function (items) {
                    $ctrl.customerGroups = items || [];
                })
                .catch(handleRequestError);
        }

        function customerGroupChanged() {
            if (
                $ctrl.companyCustomer.customerGroup &&
                $ctrl.companyCustomer.customerGroup.id === 1
            ) {
                $ctrl.companyCustomer.customerGroup = null;
            }
        }

        function initNewCustomerIntakeData() {
            CompanyCustomerCustom
                .getEmptyCompanyCustomerIntakeData()
                .query()
                .$promise
                .then(function (res) {
                    if (res) {
                        $ctrl.companyCustomer.customerIntakeData = res;
                    }
                })
                .catch(handleRequestError);
        }

        function createUser() {
            if (!$ctrl.companyCustomer.id) {
                return;
            }

            UserCustom
                .createUserByAdmin()
                .save(
                    $ctrl.companyCustomer,
                    function () {
                        loadAll();
                    },
                    handleRequestError
                );
        }

        function loadCustomerUserInfo() {
            var customerId = getCustomerId();

            if (!customerId) {
                return;
            }

            CustomerCustom
                .getCustomerUserInfoByCustomerId(customerId)
                .query()
                .$promise
                .then(function (res) {
                    $ctrl.existUser = res || {};
                    $ctrl.hasUser = Boolean($ctrl.existUser.id);
                })
                .catch(function (error) {
                    $ctrl.existUser = {};
                    $ctrl.hasUser = false;
                    handleRequestError(error);
                });
        }

        function onInvoiceHistoryTabClick() {
            if (!$ctrl.invoiceInfoList) {
                getInvoiceInfos();
            }
        }

        function getInvoiceInfos() {
            var customerId = getCustomerId();

            if (!customerId) {
                return;
            }

            InvoiceInfoCustom
                .getInvoiceByCustomerId(customerId)
                .query(
                    function (data) {
                        $ctrl.invoiceInfoList = data || [];
                        $ctrl.invoiceHistoryLoaded = true;
                    },
                    function (error) {
                        $ctrl.invoiceHistoryLoaded = true;
                        handleRequestError(error);
                    }
                );
        }

        function sendWelcomeMessage() {
            if (!$ctrl.companyCustomer.id) {
                return;
            }

            $ctrl.sendWelcomeMessageLoading = true;

            CompanyCustomerCustom
                .sendWelcomeMessage($ctrl.companyCustomer.id)
                .save(
                    {},
                    function () {
                        $ctrl.sendWelcomeMessageLoading = false;
                    },
                    function (error) {
                        $ctrl.sendWelcomeMessageLoading = false;
                        handleRequestError(error);
                    }
                );
        }

        function loadCustomerWalletData() {
            var customerId = getCustomerId();

            if (!customerId) {
                $ctrl.totalBalance = 0;
                $ctrl.walletTransactions = [];
                return;
            }

            getCustomerWalletByCustomerId(customerId);
            getWalletCreditOfCustomerId(customerId);
        }

        function getCustomerWalletByCustomerId(customerId) {
            WalletService
                .getCustomerWalletByCustomerId(customerId)
                .query(
                    function (data) {
                        $ctrl.totalBalance =
                            data && data.totalBalance
                                ? data.totalBalance
                                : 0;
                    },
                    handleRequestError
                );
        }

        function getWalletCreditOfCustomerId(customerId) {
            WalletService
                .getCreditOfCusomerId(customerId)
                .query(
                    function (data) {
                        $ctrl.walletTransactions =
                            data && data.content
                                ? data.content
                                : [];
                    },
                    handleRequestError
                );
        }

        function openAddBalanceDialog() {
            var customerId = getCustomerId();
            var useFullScreen = $mdMedia('xs') || $mdMedia('sm');
            if (!customerId) {
                return;
            }

            $mdDialog
                .show({
                    templateUrl:
                        'app/components/partial-forms/wallet/wallet-add-balance-dialog.html',
                    controller: [
                        '$scope',
                        'customerId',
                        function ($scope, customerId) {
                            $scope.customerId = customerId;
                        }
                    ],
                    locals: {
                        customerId: customerId
                    },
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
                .then(function (res) {
                    if (res && res.amount) {
                        $ctrl.totalBalance += res.amount;
                    }

                    // getCustomerWalletByCustomerId(customerId);
                    getWalletCreditOfCustomerId(customerId);
                });
        }

        function getCustomerId() {
            if (
                !$ctrl.companyCustomer ||
                !$ctrl.companyCustomer.customer
            ) {
                return null;
            }

            return $ctrl.companyCustomer.customer.id || null;
        }

        function handleRequestError(error) {
            console.error('Company customer request failed:', error);
        }

        ComponentIntakeDataDialogController.$inject = [
            '$scope',
            '$mdDialog',
            'dialogData',
            'columnCount'
        ];

        function ComponentIntakeDataDialogController(
            $scope,
            $mdDialog,
            dialogData,
            columnCount
        ) {
            var $ctrl2 = this;

            $ctrl2.customerFormData = dialogData;
            $ctrl2.columnCount = columnCount;
            $ctrl2.sidebarStatus =
                localStorage.getItem('userFavoriteSideMenu');

            $ctrl2.save = save;
            $ctrl2.cancel = cancel;
            $ctrl2.getContainerClass = getContainerClass;

            function save() {
                if (
                    !$ctrl2.customerFormData ||
                    !$ctrl2.customerFormData.companyCustomer
                ) {
                    return;
                }

                $ctrl2.customerFormData.companyCustomer.formsData = null;

                if (!$ctrl2.customerFormData.intakeData) {
                    CompanyCustomerCustom
                        .companyCustomerFormData()
                        .save(
                            $ctrl2.customerFormData,
                            saveSuccess,
                            handleRequestError
                        );
                } else {
                    CompanyCustomerCustom
                        .companyCustomerFormData()
                        .update(
                            $ctrl2.customerFormData,
                            saveSuccess,
                            handleRequestError
                        );
                }
            }

            function saveSuccess() {
                loadAll();
                $mdDialog.hide();
            }

            function cancel() {
                $mdDialog.cancel();
            }

            function getContainerClass() {
                if ($ctrl2.sidebarStatus === 'close') {
                    return 'container-wide';
                }

                if ($ctrl2.sidebarStatus === 'open') {
                    return 'container-small';
                }

                return '';
            }
        }
        
        $scope.getDynamicStyleRemoveIcon = function(tx) {
            var color = "red";
            if(tx.sourceType !== 'MANUAL') color = "unset";
            return {
                color: color
            };
        }

        $ctrl.deleteCredit = function(tx) {
            var customerId = getCustomerId()
            if(tx.sourceType !== 'MANUAL' || $ctrl.removeCreditLoading || !customerId) return
           
            DialogService
                .showConfirm('آیا از حذف این اعتبار اطمینان دارید؟')
                .then(
                    function () {
                        $ctrl.removeCreditLoading = true;
                        WalletService
                            .deleteCredit(customerId, tx.id)
                            .delete(
                                function (res) {
                                    $ctrl.removeCreditLoading = false;
                                    if (res && res.result === 'SUCCESS') {
                                        $ctrl.totalBalance =
                                            res.remainingBalance || 0;
                                        getWalletCreditOfCustomerId(customerId);
                                        $mdToast.show(
                                            $mdToast
                                                .simple()
                                                .textContent(
                                                    'مبلغ مورد نظر با موفقیت از اعتبار کم شد'
                                                )
                                                .position('top left')
                                                .hideDelay(4000)
                                                .theme('success-toast')
                                        );

                                        return;
                                    }

                                    handleRequestError(res);
                                },
                                function (err) {
                                    $ctrl.removeCreditLoading = false;
                                    handleRequestError(err);
                                }
                            );
                    },
                    function () {
                        /*
                        * کاربر دیالوگ را لغو/بسته است.
                        * نیاز به انجام کاری نیست.
                        */
                    }
                );

        }
    }

    var CompanyCustomerV2Component = {
        templateUrl:
            'app/components/partial-forms/company-customer-v2/partial-form.company-customer-v2.html',
        controller: CompanyCustomerV2ComponentController,
        bindings: {
            companyCustomer: '=',
            mode: '=',
            canSave: '='
        }
    };

    angular
        .module('tikonApp')
        .component(
            'pfCompanyCustomerV2',
            CompanyCustomerV2Component
        );

})();